import type { Prototype } from "../prototype-types";

export const liamToranPrototypes: Prototype[] = [
  {
    id: "lt-focus-xp-allocation",
    name: "FOCUS XP allocation",
    path: "/lt/focus-xp-allocation",
    description:
      "All four FOCUS experiments on one shelf: which experiment owns each hero, and what ships when they all run at once",
    owner: "Liam Toran",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/lt-focus-xp-allocation.png",
    creationTool: "claude-code",
  },
  {
    id: "lt-focus-v3-outpaint-tiles",
    name: "FOCUS outpainted apparel heroes",
    path: "/lt/focus-v3-outpaint-tiles",
    description:
      "Live heroes vs FLUX-outpainted replacements on real apparel surfaces, with the FOCUS/outpaint allocation made visible",
    owner: "Liam Toran",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/lt-focus-v3-outpaint-tiles.png",
    creationTool: "claude-code",
  },
  {
    id: "lt-focus-v3-clipped-tiles",
    name: "FOCUS v3 clipped-borders tiles",
    path: "/lt/focus-v3-clipped-tiles",
    description:
      "Live crops vs the FOCUS v3 clipped-borders XP (LQ-340) on real search results and brand pages",
    owner: "Liam Toran",
    createdAt: "2026-08-12",
    lastUpdated: "2026-08-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/lt-focus-v3-clipped-tiles.png",
    creationTool: "claude-code",
  },
  {
    id: "lt-focus-v2-zoom-tiles",
    name: "FOCUS v2 zoom-in XP tiles",
    path: "/lt/focus-v2-zoom-tiles",
    description:
      "Live crops vs the FOCUS v2 zoom-in XP (coverage 0.90) on real non-apparel search results and brand pages",
    owner: "Liam Toran",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/lt-focus-v2-zoom-tiles.png",
    creationTool: "claude-code",
  },
  {
    id: "lt-focus-v3-apparel-tiles",
    name: "FOCUS v3 apparel tiles",
    path: "/lt/focus-v3-apparel-tiles",
    description:
      "Current vs FOCUS v3 anatomy-anchored crops on real apparel surfaces: search, brand page, PDP",
    owner: "Liam Toran",
    createdAt: "2026-08-07",
    lastUpdated: "2026-08-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/lt-focus-v3-apparel-tiles.png",
    creationTool: "claude-code",
  },
  {
    id: "lt-enhance-ship-cal4",
    name: "Relight v3 cal4 ship",
    path: "/lt/enhance-ship-cal4",
    description:
      "Proposed ship: Relight v3 cal4 (faire_relight_v3b_cal4) vs cal4 plus constant-image sharpen vs half-strength sharpen vs GPT Image 2.5 vs control. S is the proposed ship, F is cal4 plus sharpen, U is half that sharpen, G is GPT, C is control.",
    owner: "Liam Toran",
    createdAt: "2026-09-21",
    lastUpdated: "2026-09-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d78167a753773b129d881f29602cb4a120b04dade9447aa25bd62c11b677356a.png",
    creationTool: "cursor",
  },
  {
    id: "lt-enhance-bakeoff-tiles",
    name: "Enhance bakeoff tiles",
    path: "/lt/enhance-bakeoff-tiles",
    description:
      "Compare control (C), Klein Wave 3 (Q), Klein v2 labels (W), Klein Wave 14 (E), Wave 16 chroma band (R), Wave 17 fidelity λ=1/256 (F, exploratory, not promoted), Cal4 + half sharpen (U), GPT Image 2.5 (1), GPT v2 labels (4), GPT pass 1 color and lighting (9), and GPT pass 1 + pass 2 resolution recovery (0), across retailer search, brand, and PDP shelves. Q/W/E/R/F select the Klein runs; press the active model key again or C to return to control. Use the Previous/Next buttons or [/] to move through the current query, brand, or product; Shift+Q and T also advance. All bakeoff images are served from CDN. Control, the band, and W17 fidelity use untagged sources with production-style display crops, including pixel autocrops; the band retains native renders up to 2048 on 692 products. W17 uses the original seed-4 fidelity arm with sources up to 1024; it failed two guardrails and the band remains serving.",
    owner: "Liam Toran",
    createdAt: "2026-09-11",
    lastUpdated: "2026-09-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d78167a753773b129d881f29602cb4a120b04dade9447aa25bd62c11b677356a.png",
    creationTool: "cursor",
  },
];
